/** @format */

import React from "react";

const TitledIframe = ({
  title,
  src,
  width = "100%",
  height = "calc(100% - 2em)",
}) => (
  <div style={{ height: "100%" }}>
    <div style={{ height: "2em", textAlign: "center" }}>{title}</div>
    <iframe
      src={src}
      title={title}
      frameBorder="0"
      allowFullScreen
      allow="vr;clipboard-write"
      style={{ width: width, height: height }}
    />
  </div>
);

const Iframe = ({ title, src, width = "100%", height = "100%" }) => (
  <div style={{ height: "100%" }}>
    <iframe
      src={src}
      title={title}
      frameBorder="0"
      allowFullScreen
      allow="vr;clipboard-write"
      style={{ width: width, height: height }}
    />
  </div>
);

export { TitledIframe, Iframe };
